<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form step2form">
      <div id="w-node-_30fb7dcd-2ec3-7e0a-fdd7-12a2e4adee03-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('NATURAL_PERSON_OWNER_VEHICLE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('NATURAL_PERSON_OWNER_VEHICLE')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
           <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.OWNER_IN_DRIVERS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.OWNER_IN_DRIVERS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('LIVING_COUNTY')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-6"><label class="field_label">{{$t('LIVING_COUNTY')}}</label></div>
            <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_DRIVERS.DISTRICT">
              <!-- <option class="dropdown-link w-dropdown-link" value="" selected>{{$t('SELECT_COUNTY')}}</option> -->
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'DISTRICT')" :key="item.VALUE" :value="item.VALUE">{{ item.TEXT || $t('SELECT_COUNTY')}}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_743401ba-2f57-df92-66a7-6fba8d49e5b9-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('OWNER_DRIVING_LICENSE_YEARS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('OWNER_DRIVING_LICENSE_YEARS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-3" v-for="item in $h.getLov(data.ET_LOVS, 'DRIVER_LICENSE_YEAR')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.DRIVER_LICENSE_YEAR === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.DRIVER_LICENSE_YEAR" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div class="form_field">
        <validation-provider class="w-100" :name="$t('HOW_MANY_DRIVERS_INCLUDING_OWNER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('HOW_MANY_DRIVERS_INCLUDING_OWNER')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'NO_OF_DRIVERS')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.NO_OF_DRIVERS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.NO_OF_DRIVERS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-bdb81198-14f3-2268-7faa-4c65287fc0bf-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('GIC_INSURED_LEAST_2YEARS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('GIC_INSURED_LEAST_2YEARS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
           <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.INSURED_DRIVERS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.INSURED_DRIVERS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_1704a60d-5c6e-5294-f5f0-5d9b0d717830-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('INCREASED_PREMIUM')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('INCREASED_PREMIUM')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
           <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.INCREASED_PREMIUM === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.INCREASED_PREMIUM" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_48a84227-b6ee-a46a-17a3-e128e4b86e3a-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('ANY_COMPANY_REFUSED_TO_COVER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('ANY_COMPANY_REFUSED_TO_COVER')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.REFUSED_BY_IC === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.REFUSED_BY_IC" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div class="form_field">
        <validation-provider class="w-100" :name="$t('CONDITION_ILLNESS_DISABILITY')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('CONDITION_ILLNESS_DISABILITY')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.DRIVER_INVALIDITY === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.DRIVER_INVALIDITY" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-ae1818b7-304b-41fe-9ec0-8cb100b111c1-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('LICENSE_AT_LEAST_2_YEARS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('LICENSE_AT_LEAST_2_YEARS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
           <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.ALL_DRIVERS_CYPRIOT_LICENSE === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.ALL_DRIVERS_CYPRIOT_LICENSE" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_02d4eb69-bc8b-5b59-cbfb-7e302f1fac62-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('DRIVERS_BETWEEN_25_70_YERS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('DRIVERS_BETWEEN_25_70_YERS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.DRIVERS_BETWEEN_25_70 === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.DRIVERS_BETWEEN_25_70" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-bf12b13b-0fbe-b2bd-4f25-d63c718f414d-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('CLAIMS_LAST_THREE_YEARS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('CLAIMS_LAST_THREE_YEARS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.CLAIMS_IN_PREV_3_YEARS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.CLAIMS_IN_PREV_3_YEARS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_6ae54be8-12f4-69cf-4021-5f2bfe941b33-c33646d5" class="form_field">
        <validation-provider class="w-100" :name="$t('DRIVERS_LIVE_IN_CYPRUS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('DRIVERS_LIVE_IN_CYPRUS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_DRIVERS.DRIVERS_LIVE_IN_CYPRUS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_DRIVERS.DRIVERS_LIVE_IN_CYPRUS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_53fa47d3-bf71-f84f-60d2-1bd9fa93ad96-c33646d5" class="div-block-8">
        <button type="submit" class="submit-button w-button">{{ $t('CONTINUE') }}</button>
        </div>
    </form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    submitForm() {
      console.log('calcult');
      this.$emit('motor-calculation');
    }
  }
};
</script>
